/**
 * @param {string} url
 * @returns {{ width: string, height: string }}
 */
export default function getStoryblokImageDimensions(url) {
  try {
    if (!url) throw new Error('Image URL is required.')
    const [width, height] = url.split('/')[5].split('x')
    return { width, height }
  } catch (error) {
    console.error(error)
    return { width: '', height: '' }
  }
}
